export const projectIndex = (response, mutationOrSubscription, draft) => {
  const res = response?.data?.[mutationOrSubscription]?.projectStaff?.projectId
  if (!res) return
  return draft.findIndex(project => project.id === res)
}

export const insertStaffInProject = (project, projectIndex, staff, draft) => {
  draft[projectIndex].projectConnection.push(staff)
}
